/**
 * Helper for defect group denominator. Maps denominator type (sample_size, avos_fruit, 100)
 * to a numeric value. Pass sample_size and avos_fruit (e.g. from one check or sums).
 */

export interface DefectGroupWithDenominator {
    denominator?: string;
}

/**
 * Returns the denominator value from defect group config and the given sample_size and avos_fruit.
 */
export function getDefectGroupDenominator(
    defect_group: DefectGroupWithDenominator,
    sample_size: number,
    avos_fruit: number
): number {
    const d = defect_group.denominator;
    if (d === "sample_size") return sample_size;
    if (d === "100") return 100;
    return avos_fruit;
}
